import { simGridSizes } from 'src/rSimInventory/Details/RSimInventoryDetailsPage.style';
import { SectionGridItem } from '../../SectionGrid/SectionGridItem';
import { SectionGridRow } from '../../SectionGrid/SectionGridRow';
import { useTranslation } from 'react-i18next';
import { CustomFieldProp, FIELD_TYPE } from 'src/admin/customFields/entities/customFields.entity';

type CustomFieldsDetailsProps = {
  rSimView: boolean;
  customFields?: CustomFieldProp[];
};

export const CustomFieldsDetails = ({ rSimView, customFields }: CustomFieldsDetailsProps) => {
  const { t } = useTranslation();

  if (!customFields) {
    return null;
  }

  const mappedCustomFields: CustomFieldProp[] = [];
  customFields?.forEach((field: CustomFieldProp) => {
    const index = mappedCustomFields.findIndex((f) => f.label === field.label);
    if (index > -1) {
      const values = mappedCustomFields[index].selectionOption?.split(', ') || [];
      if (field.selectionOption && !values.includes(field.selectionOption)) {
        values.push(field.selectionOption);
      }
      mappedCustomFields[index].selectionOption = values.join(', ');
    } else {
      mappedCustomFields.push(field);
    }
  });

  return mappedCustomFields.length > 0 ? (
    <SectionGridRow
      title={t('simInventory.customFields')}
      sx={{
        pl: rSimView ? 0 : 12,
        textTransform: 'capitalize',
      }}
    >
      {mappedCustomFields.map((field) => (
        <SectionGridItem
          key={field.label}
          value={field.dataType === FIELD_TYPE.Dropdown ? field.selectionOption : field.textValue}
          label={field.label}
          testId={`customField-${field.label}`}
          customGridSizes={rSimView ? simGridSizes : null}
        />
      ))}
    </SectionGridRow>
  ) : null;
};
